import { Box, Button, TextField } from '@mui/material'
import { Formik } from 'formik'
import useMediaQuery from '@mui/material/useMediaQuery'
import Header from '../../components/Header'

import React from "react"
import { useState } from "react"
import { useParams } from 'react-router-dom'

import * as Constants from '../../constants'

const EditOwner = () => {
  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const owner_id = useParams().id

  const isNonMobile = useMediaQuery('(min-width:600px)')

  const handleFormSubmit = (values) => {
    fetch(Constants.HOST + '/editOwner', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        owner_id: owner_id,
        name: values.newname,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success) {
              setError({ error: false, message: '' })
              setSuccess({
                success: true,
                message: 'Usuário editado com sucesso',
              })
            } else {
              setSuccess({ success: false, message: '' })
              setError({ error: true, message: data.message })
            }
          })
        }
      })
      .catch(() => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  return (
    <Box m="20px">
      <Header title="Alterar nome do proprietário" />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="20px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="newname"
                label="Novo nome"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.newname}
                name="newname"
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  )
}

const initialValues = {
  newname: '',
}

export default EditOwner
